import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { ItemToReturn } from '../../models/returns';
import ReturnReviewCard from '../shared/summary-cards/ReturnReviewCard';
import ReviewItemDetails from './ReviewItemDetails';

interface InStoreDropOffCardProps {
  items: ItemToReturn[];
  onEditItemSubmit: (
    startingState: ItemToReturn,
    closeDrawer: () => void,
  ) => void;
  onRemoveItemSubmit: (selectedItemId: string) => void;
  isEditSubmitting: boolean;
}

export const InStoreDropOffCard = ({
  items,
  onEditItemSubmit,
  onRemoveItemSubmit,
  isEditSubmitting,
}: InStoreDropOffCardProps) => {
  return (
    <ReturnReviewCard header="In-Store Return">
      {/* Items List */}
      <div className="sui-space-y-6">
        {items.length === 0 ? (
          <div className="sui-text-center sui-py-4">
            <Typography>No items selected for return</Typography>
          </div>
        ) : (
          items.map((item, index) => (
            <ReviewItemDetails
              item={item}
              index={index}
              onEditItemSubmit={onEditItemSubmit}
              onRemoveItemSubmit={onRemoveItemSubmit}
              isEditSubmitting={isEditSubmitting}
              key={`${item.lineItemId}-${index}`}
            />
          ))
        )}
      </div>
    </ReturnReviewCard>
  );
};
